import { useContext, useRef } from "react";
import GlobalContext from "../context/Global";
import { syncOpenHouseAttendees } from "../services/attendeeSubmission";

export const useSyncUnsyncedAttendees = () => {
  const { user } = useContext(GlobalContext);
  const lastSyncRef = useRef<number | null>(null);
  const isSyncingRef = useRef(false);

  return async (openHouseUuid: string) => {
    if (!openHouseUuid || !user?.id || isSyncingRef.current) return;

    const now = Date.now();
    if (lastSyncRef.current && now - lastSyncRef.current < 10_000) return;

    isSyncingRef.current = true;
    try {
      await syncOpenHouseAttendees(openHouseUuid, user.id);
      lastSyncRef.current = Date.now();
    } catch (error) {
      console.error("Error syncing attendees:", error);
    } finally {
      isSyncingRef.current = false;
    }
  };
};
